export class RestoreGcpDiskRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "providerDiskId",
            "baseName": "providerDiskId",
            "type": "string",
            "format": ""
        },
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "destination",
            "baseName": "destination",
            "type": "GcpDiskRestoreDestination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreGcpDiskRequest.attributeTypeMap;
    }
    constructor() {
    }
}
